export const routesRaporIkYemek = [
  {
    path: "/rapor_ik_yemek",
    name: "rapor_ik_yemek",
    component: () => import("@/views/mesai/rapor_ik_yemek/index.vue"),
    meta: {
      public: false,
      title: "mesai.Yemek Hakediş Listesi",
      yetki: { k: [1014002] },
    },
  },
]
